/* eslint react/prop-types: 0 */
import Carousel from 'nuka-carousel';
import PropTypes from 'prop-types';
import React from 'react';
import MediaQuery from 'react-responsive';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { ModelYear, Quote } from '@sm360/widget-commons-vehicle';

import { MEDIA_QUERIES } from '@sm360/widget-commons-general';
import URL from 'build-and-quote/constants/url.js';

import 'build-and-quote/components/ModelTrims/modelTrimImages.scss';

const ModelTrimImages = ({ imageServerDomain, optionsPackageImageUrls, optionsPackageConfiguration }) => {
    const imageServerNewcar = imageServerDomain
        ? imageServerDomain.imageServerDomain + imageServerDomain.imageServerRelative
        : undefined;

    const decorators = [
        {
            component: ({ currentSlide, previousSlide }) => {
                let previousSlideUrl = null;
                if (currentSlide === 1) {
                    previousSlideUrl = optionsPackageImageUrls.photo3;
                } else if (currentSlide === 2) {
                    previousSlideUrl = optionsPackageImageUrls.photo1;
                }
                return (
                    previousSlideUrl && (
                        <button
                            onClick={previousSlide}
                            alt={LocaleService.t('PREVIOUS_SLIDE')}
                            title={LocaleService.t('PREVIOUS_SLIDE')}
                            className="slider-decorator--single"
                        />
                    )
                );
            },
            position: 'CenterLeft',
            style: {
                width: '20%',
                height: '100%',
            },
        },
        {
            component: ({ currentSlide, nextSlide }) => {
                return (
                    currentSlide < 2 && (
                        <button
                            onClick={nextSlide}
                            alt={LocaleService.t('NEXT_SLIDE')}
                            title={LocaleService.t('NEXT_SLIDE')}
                            className="slider-decorator--single"
                        />
                    )
                );
            },
            position: 'CenterRight',
            style: {
                width: '20%',
                height: '100%',
            },
        },
        {
            component: ({ previousSlide }) => {
                return (
                    previousSlide && (
                        <div className="slider-decorator--bottom">
                            <button
                                onClick={previousSlide}
                                alt={LocaleService.t('PREVIOUS_SLIDE')}
                                title={LocaleService.t('PREVIOUS_SLIDE')}
                            >
                                <icon className="icon-keyboard-arrow-left" />
                            </button>
                        </div>
                    )
                );
            },
            position: 'CenterLeft',
        },
        {
            component: ({ nextSlide }) => {
                return (
                    nextSlide && (
                        <div className="slider-decorator--bottom">
                            <button
                                onClick={nextSlide}
                                alt={LocaleService.t('NEXT_SLIDE')}
                                title={LocaleService.t('NEXT_SLIDE')}
                            >
                                <icon className="icon-keyboard_arrow_right" />
                            </button>
                        </div>
                    )
                );
            },
            position: 'CenterRight',
        },
    ];

    const optionPackage = optionsPackageConfiguration && optionsPackageConfiguration.exteriorColourStatus;
    const imageStatus = Quote.exteriorColourStatuses.IMAGE_STATUS;
    const warningMessage = optionsPackageConfiguration &&
        optionPackage !== imageStatus.FULL_COLORIZED && (
            <div className="style-slider__photo-avalaible">
                <p className="is-light">
                    {optionPackage === imageStatus.NO_IMAGE
                        ? LocaleService.t('MISSING_PHOTO.NO_PHOTO')
                        : LocaleService.t('MISSING_PHOTO.REFERENCE_PHOTO')}
                </p>
            </div>
        );

    const hasPhotosAndVideos = false;
    const hasPhotos = false;
    const hasVideos = false;

    const carouselCommonProps = {
        edgeEasing: 'easeInOutQuint',
        className: 'modelTrim-slide',
        cellAlign: 'center',
        slidesToShow: 1,
        slideIndex: 1,
        dragging: true,
        decorators,
    };

    const slides = optionsPackageImageUrls &&
        imageServerNewcar && [
            <img alt="photo3" src={imageServerNewcar + optionsPackageImageUrls.photo3} />,
            <img alt="photo1" src={imageServerNewcar + optionsPackageImageUrls.photo1} />,
            <img alt="photo2" src={imageServerNewcar + optionsPackageImageUrls.photo2} />,
        ];

    return (
        <section className="style-slider">
            {optionsPackageImageUrls ? (
                <div>
                    <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                        <Carousel {...carouselCommonProps} slideWidth={0.5}>
                            {slides}
                        </Carousel>
                    </MediaQuery>
                    <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                        <Carousel {...carouselCommonProps} slideWidth={1}>
                            {slides}
                        </Carousel>
                    </MediaQuery>
                </div>
            ) : (
                <div className="style-slider__missing-photo">
                    <p className="style-slider__missing-photo-label sr-text is-bold">
                        {LocaleService.t('MISSING_PHOTO.NOT_AVAILABLE')}
                    </p>
                    <img
                        alt={LocaleService.t('MISSING_PHOTO.NOT_AVAILABLE')}
                        src={imageServerDomain && `${imageServerDomain.imageServerDomain}/ir/w600c${URL.NO_PHOTO}`}
                    />
                </div>
            )}
            {warningMessage}
            {hasPhotosAndVideos && (
                <div className="style-buttons">
                    <ul>
                        {hasPhotos && (
                            <li>
                                <button className="style-button">
                                    <icon className="icon-Photos" />
                                    <span>
                                        {LocaleService.t('modelTrimSection.lengthPictures', {
                                            length: 'xx',
                                        })}
                                    </span>
                                </button>
                            </li>
                        )}
                        {hasVideos && (
                            <li>
                                <button className="style-button">
                                    <icon className="icon-play-button" />
                                    <span>{LocaleService.t('modelTrimSection.seeVideo')}</span>
                                </button>
                            </li>
                        )}
                    </ul>
                </div>
            )}
        </section>
    );
};

ModelTrimImages.propTypes = {
    imageServerDomain: PropTypes.string.isRequired,
    optionsPackageImageUrls: PropTypes.instanceOf(ModelYear.ColourModel).isRequired,
    optionsPackageConfiguration: PropTypes.instanceOf(ModelYear.ModelTrimConfigurationModel).isRequired,
};

ModelTrimImages.displayName = 'ModelTrimImages';

export default ModelTrimImages;
